import * as yup from "yup";

export const schemaData = yup.object().shape({
  customer: yup.number().required("Campo obrigatório"),
  department: yup.number().required("Campo obrigatório"),
  classification: yup.number().required("Campo obrigatório"),
  situation: yup.number().required("Campo obrigatório"),
});
